var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_444_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4C8.97676 4 7.74194 5.24487 7.74194 6.78049C7.74194 8.31611 8.97676 9.56098 10.5 9.56098C12.0232 9.56098 13.2581 8.31611 13.2581 6.78049C13.2581 5.24487 12.0232 4 10.5 4Z",
    fill: "#6638A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75806 10.439C7.23483 10.439 6 11.6839 6 13.2195C6 14.7551 7.23483 16 8.75806 16H12.2419C13.7652 16 15 14.7551 15 13.2195C15 11.6839 13.7652 10.439 12.2419 10.439H8.75806Z",
    fill: "#6638A2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    fill: "white",
    transform: "translate(6 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_444_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSmall);
export default __webpack_public_path__ + "static/media/user-small.1facdc32df39a6c72ce6c9227a93faae.svg";
export { ForwardRef as ReactComponent };